import { render } from "./SkeletonTitleIcon.vue?vue&type=template&id=191f2181"
import script from "./SkeletonTitleIcon.vue?vue&type=script&lang=js"
export * from "./SkeletonTitleIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__